<template>
	<div>
		<div class="content">
			<div class="panel panel-sign">
				<div class="container">
					<div class="box clearfix">
						<div class="login-secondary">
							<div class="login-secondary-logo">
								<!-- <img src="../../static/images/home/logo.jpg" /> -->
							</div>
							<div class="login-secondary-down clearfix">
								<div class="tips">
									<h3>关注{{$namePc}}公众号</h3>
									<p>手机提交卡券更方便</p>
								</div>
								<div class="down pull-left">
									<div class="qr pull-right">
										<img :src="settingPc && settingPc.wxmp_img?settingPc.wxmp_img.file_path:''" />
										<p>微信扫码关注公众号</p>
									</div>
								</div>

							</div>
						</div>
						<div class="login-primary">
							<div class="pc-login">
								<div class="login-tab">
									<a href="javascript:;" :class="{'active':tabIndex === 1}" @click="tabIndex = 1">
										帐号密码登录
									</a>
									<span class="sep">|</span>
									<a href="javascript:;" :class="{'active':tabIndex === 2}" @click="tabIndex = 2">
										手机验证码登录
									</a>
								</div>
								<div class="login-content signform mt30" v-if="tabIndex === 1">

									<div class="form-group">
										<label class="control-label">
											<i class="iconfont icon-yonghu"></i>
										</label>
										<el-tooltip popper-class='tooltip-back' :hide-after='4' :manual="true" :value="visibleUser" effect="dark" :content="msgUser" placement="top-start">
											<input class="form-control" @focus="visibleUser=false" v-model="userAccount" :class="{'form-control-error':visibleUser}" placeholder="账号/手机号码"  />
										</el-tooltip>

									</div>
									<div class="form-group">
										<label class="control-label">
											<i class="iconfont icon-icon-"></i>
										</label>
										<el-tooltip popper-class='tooltip-back' :hide-after='4' :manual="true" :value="visiblePass" effect="dark" :content="msgPass" placement="top-start">
											<input class="form-control"  @keydown.enter="userLogin"  @focus="visiblePass=false" type="password" v-model="userPass" :class="{'form-control-error':visiblePass}" placeholder="登录密码"  />
										</el-tooltip>

									</div>
									<div class="form-group">
										<button class="btn btn-primary" @click="userLogin()">登录</button>
										<div class="form-attach">
											<a class="text-light">没有账号？</a>
											<span class="sep">|</span>
											<router-link  :to="{path:'/register'}">
												<a href="javascript:;" class="text-blue">立即注册</a>
											</router-link>
										</div>
									</div>
								</div>
								<div class="login-content signform mt30" v-if="tabIndex === 2">
									<div class="form-group">
										<label class="control-label">
											<i class="iconfont icon-shouji"></i>
										</label>
										<input class="form-control" type="number"  @focus="visiblePhone=false" v-model="mobile" :class="{'form-control-error':visiblePhone}" placeholder="手机号码"  />
									</div>
									<div class="form-group">
										<label class="control-label">
											<i class="iconfont icon-icon- "></i>
										</label>
										<el-tooltip popper-class='tooltip-back' :manual="true" :value="visibleCode" effect="dark" :content="msgCode" placement="top-start">
											<input class="form-control"  @keydown.enter="phongLogin"  @focus="visibleCode=false" v-model="mobileCode" :class="{'form-control-error':visibleCode}" placeholder="手机验证码"  />

										</el-tooltip>
										<a href="javascript:;" class="absolute-right text-blue" @click="getCode()" :class="{disabled:time!=0}">
											{{time === 0?'获取短信验证码':time+'秒后可重新获取'}}
										</a>
									</div>
									<div class="form-group">
										<button class="btn btn-primary" @click="phongLogin()">登录</button>
										<div class="form-attach">
											<a class="text-light">没有账号？</a>
											<span class="sep">|</span>
											<router-link  :to="{path:'/register'}">
												<a href="javascript:;" class="text-blue">立即注册</a>
											</router-link>
										</div>
									</div>
								</div>
		<!-- 						<div class="login-other">
									<label>其他登录方式： </label>
									<a class="login-other-wechat" @click="$commonJs.checkWxLogin">
										<i class="iconfont icon-weixin1"></i>
										微信账号授权登录
									</a>
								</div> -->
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		name:"Login",
		data(){
			return{
				tabIndex:1,
				time:0,
				visiblePhone: false,
				visibleCode:false,
				visiblePass:false,
				visibleUser:false,
				msgCode:"",
				msgPass:"",
				msgUser:"",
				userAccount:"",
				userPass:"",
				mobile:"",
				mobileCode:"",
				interval:null,
        settingPc:{}
			}
		},
		created(){
      this.settingPc = JSON.parse(localStorage.getItem('settingPc'))
		},
		methods:{
//
			getCode(){
				if(!this.mobile){
					this.$message({
						message: '手机号不能为空',
						type: 'warning'
					});
					this.visiblePhone = true
					return
				}
				if(this.$fxLink.checkPhone(this.mobile)){
					this.$message({
						message: '手机号格式不正确',
						type: 'warning'
					});
					this.visiblePhone = true
					return
				}
				if (this.time == 0){

					this.$api.sendSmsCaptcha({
						mobile:this.mobile,
					}).then(res => {
						if(res.code === 1){
							this.$message({
								message: res.msg,
								type: 'warning'
							});
							this.time = 60 ;
							this.interval = setInterval(() => {
								if(this.time == 0){
									clearInterval(this.interval)
									return
								}
								this.time --
							},1000)
						}else{
							this.$message({
								message: res.msg,
								type: 'warning'
							});
							return
						}

					})
				}
			},
			phongLogin(){
				if(!this.mobile){
					this.$message({
						message: '手机号不能为空',
						type: 'warning'
					});
					this.visiblePhone = true
					return
				}
				if(this.$fxLink.checkPhone(this.mobile)){
					this.$message({
						message: '手机号格式不正确',
						type: 'warning'
					});
					this.visiblePhone = true
					return
				}
				if(!this.mobileCode){
					this.$message({
						message: '手机号格式不正确',
						type: 'warning'
					});
					this.visibleCode = true
					return
				}
				this.$api.login_phone({
					phone: this.mobile,
					code:this.mobileCode,
					type:this.$postType
				}).then(res => {
					if(res.code === 1){
						this.$message({
							message: '登录成功',
							type: 'success'
						});
						let token = res.data
						localStorage.setItem("token",token)
						this.$api.userInfo({
							token
						}).then(result => {
							if(result.code === 1){
								localStorage.setItem("userInfo",JSON.stringify(result.data))
								this.$router.push({ path:'/user'})
								window.location.reload();
							}else{
								this.$message({
									message: res.msg,
									type: 'warning'
								});
							}
						})
					}else{
						this.$message({
							message: res.msg,
							type: 'warning'
						});
					}

				})
			},
			userLogin(){
				if(!this.userAccount){
					this.visibleUser = true
					this.msgUser = '账号/手机不能为空'
					return
				}
				if(!this.userPass){
					this.visiblePass = true
					this.msgPass = '密码不能为空'
					return
				}

				this.$api.login({
					phone: this.userAccount,
					password:this.userPass,
					type:this.$postType
				}).then(res => {
					if(res.code === 1){
						this.$message({
							message: '登录成功',
							type: 'success'
						});
						let token = res.data.token
						localStorage.setItem("token",token)
						this.$api.userInfo({
							token
						}).then(result => {
							if(result.code === 1){
								localStorage.setItem("userInfo",JSON.stringify(result.data))
								this.$router.push({ path:'/user'})
								window.location.reload();
							}else{
								this.$message({
									message: res.msg,
									type: 'warning'
								});
							}
						})
					}else{
						this.$message({
							message: res.msg,
							type: 'error'
						});
					}

				})
			},
		}
	}
</script>

<style>
	.panel-sign {
		position: relative;
		padding: 100px 0;
		background-color: #f9fafe!important;
	}
	.signform .absolute-right {
		line-height: 50px;
		padding: 0 15px 0 0;
		font-size: 14px;
	}
	.tooltip-back{
		background-color: #f96868!important;
	}
	.tooltip-back div{
		border-top-color: #f96868!important;
	}
	.tooltip-back div::after{
		border-top-color: #f96868!important;
	}
	.signform .control-label {
	    position: absolute;
	    top: 0;
	    left: 0;
	    line-height: 52px;
	    padding: 0;
	}
  .loginstdz{
  	margin-top: 5px;

  }
</style>



// WEBPACK FOOTER //
// src/components/login/login.vue